export interface Category {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "sukan",
    name: "抖漫速看",
    tagline: "一分钟看懂一部好漫画",
    description: "精选人气作品的三分钟速看解析，剧情脉络、角色设定、高能亮点一网打尽，通勤路上快速入坑。",
    icon: "ri-flashlight-line",
  },
  {
    slug: "jingxuan",
    name: "抖漫精选",
    tagline: "编辑严选的口碑佳作",
    description: "由资深编辑从海量作品中严选出来的高分漫画，覆盖都市、悬疑、恋爱、冒险等多种题材。",
    icon: "ri-star-line",
  },
  {
    slug: "pianduan",
    name: "抖漫片段",
    tagline: "高能名场面一网打尽",
    description: "把一部漫画里最燃、最虐、最好笑的名场面单独剪出来，碎片时间也能过足瘾。",
    icon: "ri-clapperboard-line",
  },
  {
    slug: "tongqin",
    name: "通勤时刻",
    tagline: "早晚高峰的轻松陪伴",
    description: "为通勤场景量身打造，节奏明快、随时能停，让等车坐地铁的时间不再无聊。",
    icon: "ri-train-line",
  },
  {
    slug: "shuiqian",
    name: "睡前放松",
    tagline: "温柔治愈的晚安故事",
    description: "暖色调治愈系漫画，画风温柔、剧情舒缓，陪你卸下一天的疲惫安然入睡。",
    icon: "ri-moon-line",
  },
  {
    slug: "richang",
    name: "日常治愈",
    tagline: "琐碎生活里的小确幸",
    description: "聚焦生活里那些微小而温暖的瞬间，猫咪、美食、老友，把平淡日常画出光来。",
    icon: "ri-cup-line",
  },
];